"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _BufferSettings = _interopRequireDefault(require("./BufferSettings"));
var _ChannelInfo = _interopRequireDefault(require("./ChannelInfo"));
var _ChannelBanlist = _interopRequireDefault(require("./ChannelBanlist"));
var _default = exports.default = {
  components: {
    BufferSettings: _BufferSettings.default,
    ChannelInfo: _ChannelInfo.default,
    ChannelBanlist: _ChannelBanlist.default
  },
  props: ['buffer', 'sidebarState'],
  data() {
    return {
      self: this,
      pluginUiQueryElements: _GlobalApi.default.singleton().queryHeaderPlugins
    };
  },
  computed: {
    showHeader() {
      // Plus de topic ni de boutons pour un salon rejoint → header masqué.
      // Conservé pour : salon non rejoint (bouton « Rejoindre »), serveur
      // (bouton Connexion), privé (profil / ignorer).
      if (this.isServer() || this.isQuery()) {
        return true;
      }
      if (this.isChannel()) {
        return !this.isJoined && this.isConnected;
      }
      return false;
    },
    isJoined() {
      let buffer = this.buffer;
      return buffer.getNetwork().state === 'connected' && buffer.joined;
    },
    isConnected() {
      return this.buffer.getNetwork().state === 'connected';
    },
    network() {
      return this.buffer.getNetwork();
    },
    sidebarSection() {
      return this.sidebarState.section();
    },
    userOnline() {
      let user = this.$state.getUser(this.buffer.getNetwork().id, this.buffer.name);
      return !!user;
    },
    // Salon d'où l'on vient (flèche « retour » d'un privé) : renvoyé UNIQUEMENT
    // sur mobile, et seulement si le buffer précédemment actif est un SALON
    // (pas un autre privé). null sinon → pas de flèche.
    previousChannelBuffer() {
      if (!this.$state.ui.is_narrow) {
        return null;
      }
      let prev = this.$state.ui.previous_active_buffer;
      if (!prev) {
        return null;
      }
      let buffer = this.$state.getBufferByName(prev.networkid, prev.name);
      return buffer && buffer.isChannel() ? buffer : null;
    }
  },
  methods: {
    isChannel() {
      return this.buffer.isChannel();
    },
    isServer() {
      return this.buffer.isServer();
    },
    isQuery() {
      return this.buffer.isQuery();
    },
    isSpecial() {
      return this.buffer.isSpecial();
    },
    showNetworkSettings(network) {
      network.showServerBuffer('settings');
    },
    onConnectButtonClick() {
      let network = this.buffer.getNetwork();
      if (!network.connection.server) {
        network.showServerBuffer('settings');
      } else {
        network.ircClient.connect();
      }
    },
    toggleUser() {
      let user = this.$state.getUser(this.buffer.getNetwork().id, this.buffer.name);
      this.sidebarState.toggleUser(user);
    },
    goBackToPrevious() {
      let buffer = this.previousChannelBuffer;
      if (buffer) {
        this.$state.setActiveBuffer(buffer.networkid, buffer.name);
      }
    },
    joinCurrentBuffer() {
      let network = this.buffer.getNetwork();
      this.buffer.enabled = true;
      network.ircClient.join(this.buffer.name);
    },
    onHeaderClick(event) {
      let channelName = event.target.getAttribute('data-channel-name');
      if (channelName) {
        let network = this.buffer.getNetwork();
        this.$state.addBuffer(this.buffer.networkid, channelName);
        network.ircClient.join(channelName);
      }
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["ContainerHeader"]
window._app_exports.components.ContainerHeader = exports.default ? exports.default : exports;
